import React from 'react';
import { observer } from 'mobx-react-lite';
import {
  BetNotificationWr,
  SlowConnectionWr,
  UnderMaintenanceWr,
  userInfoStore,
  freeBetStore,
  gameConfigStore,
} from '@pascal/pascal-core';
import {
  AdditionalErrorMessages,
  AdditionalNotificationByResponseCode,
  AdditionalResponseCode,
} from '../../enums';
import { gameStore, inputValidationStore } from '../../store';
import { GameContent } from '../../components/common/gameContent';

export const GameMain = observer(() => {
  const { currencyCode } = userInfoStore;
  const { minOdd } = gameStore;
  const { activeFreeBet } = freeBetStore;
  const dynamicData = {
    ...inputValidationStore.dynamicValidationType,
    currencyCode,
  };
  const { maxAutoCashOutOdd } = gameConfigStore;

  return (
    <div className='crash'>
      {/* todo this comment needed */}
      {/* <LocalStorageWrapper localStorageKey={specificLocalStorageKeys.isHideHalfCashOut}> */}
      {/*  <HalfCashOutPopUp t={t} /> */}
      {/* </LocalStorageWrapper> */}

      <BetNotificationWr
        autoCashOutMinOdd={activeFreeBet?.minOdd || minOdd}
        autoCashOutMaxOdd={maxAutoCashOutOdd}
        translationDynamicValues={dynamicData}
        AdditionalErrorMessages={AdditionalErrorMessages}
        AdditionalNotificationByResponseCode={AdditionalNotificationByResponseCode}
        AdditionalResponseCode={AdditionalResponseCode}
      />
      <UnderMaintenanceWr />
      <SlowConnectionWr />
      <GameContent />
    </div>
  );
});
